const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x02e487ebF5759D222A97c7ed69C6e2a0Adfa2AFf',
  busdAddress: '0xd9ba894e0097f8cc2bbc9d24d308b98e36dc6d02',
  lpAddress: '0x0d2f1515657e3424c6534e4701e8849c8957667e'
}

export default priceContracts